module.exports = __webpack_public_path__ + "superhero-banner-bgwpe6d55d536beb65dba312078fa0755c8c.png";